import { defaultApi, defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  AssetsQuerySchema,
  ConfirmUploadItemSchema,
  ConfirmUploadResponseSchema,
  DefaultCreativeItemSchema,
  DefaultCreativesRequestSchema,
  DefaultCreativesResponseSchema,
  UploadUrlsItemSchema,
  UploadUrlsRequestSchema,
  UploadUrlsResponseSchema,
} from '../shared/schemas/assets.js';

export const getUploadUrls = defaultClient.mutation({
  url: 'omni-trafficking/v1/assets/upload-urls/' as const,
  method: 'POST',
  requestSchema: UploadUrlsRequestSchema,
  responseSchema: UploadUrlsResponseSchema,
  processResponse(data) {
    return data?.data?.items ?? [];
  },
  querySchema: AssetsQuerySchema,
  snakeCaseQueryParams: true,
});

export const confirmUpload = defaultApi.declareEndpoint({
  url: 'omni-trafficking/v1/assets/$assetId/confirm-upload/' as const,
  method: 'POST',
  responseSchema: ConfirmUploadResponseSchema,
  querySchema: AssetsQuerySchema,
  snakeCaseQueryParams: true,
});

export const getDefaultCreatives = defaultClient.query({
  url: 'omni-trafficking/v1/assets/campaign-manager/default-creatives/' as const,
  method: 'POST',
  requestSchema: DefaultCreativesRequestSchema,
  responseSchema: DefaultCreativesResponseSchema,
  processResponse(data) {
    return data?.data?.items ?? [];
  },
  querySchema: AssetsQuerySchema,
  snakeCaseQueryParams: true,
});

export type DefaultCreativesRequestType = z.infer<
  typeof DefaultCreativesRequestSchema
>;
export type DefaultCreativeItemType = z.infer<typeof DefaultCreativeItemSchema>;
export type DefaultCreativesResponseType = z.infer<
  typeof DefaultCreativesResponseSchema
>;

export type UploadUrlsRequestType = z.infer<typeof UploadUrlsRequestSchema>;
export type UploadUrlsItemType = z.infer<typeof UploadUrlsItemSchema>;
export type UploadUrlsResponseType = z.infer<typeof UploadUrlsResponseSchema>;
export type ConfirmUploadItemType = z.infer<typeof ConfirmUploadItemSchema>;
export type ConfirmUploadResponseType = z.infer<
  typeof ConfirmUploadResponseSchema
>;
